import * as React from 'react'

function DownloadGreyIcon(props: any) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={32} height={32} viewBox="0 0 32 32" {...props}>
      <g data-name="Group 55373" transform="translate(-1728 -266)">
        <rect width={32} height={32} rx={4} transform="translate(1728 266)" fill="#ecf0f1" />
        <g data-name="Group 52715">
          <g data-name="Group 53635">
            <path
              data-name="Path 17173"
              d="M7.866 1.385H0V0h7.866z"
              transform="translate(1735.999 275) rotate(-90 7.586 .28)"
              fill="#263238"
            />
            <path
              data-name="Path 17173"
              d="M16 1.385H0V0h16z"
              transform="translate(1735.999 275) translate(0 12.615)"
              fill="#263238"
            />
            <path
              data-name="Path 17173"
              d="M7.143 1.385H0V0h7.143z"
              transform="translate(1735.999 275) rotate(-90 6.629 6.628)"
              fill="#263238"
            />
            <path
              data-name="Path 17173"
              d="M7.143 1.385H0V0h7.143z"
              transform="translate(1735.999 275) rotate(-90 13.936 -.68)"
              fill="#263238"
            />
            <g data-name="Group 52706">
              <path
                data-name="Subtraction 152"
                d="M5.689 5.633L0 5.689.055 0l1.373 1.373L1.4 4.289l2.917-.028 1.371 1.372z"
                fill="#263238"
                transform="translate(1735.999 275) rotate(-45 8.628 -2.05)"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}
export default DownloadGreyIcon
